import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';

class BookingStatusDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicClass: this.getClassFromValue(props.value),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const newClass = this.getClassFromValue(this.props.value);
      if (newClass !== this.state.dynamicClass) {
        this.handleDynamicClass(newClass);
      }
    }
  }

  getClassFromValue = (value) => {
    const { options } = this.props;
    const selected = options.find(opt => opt.value === value);
    return selected && selected.className ? selected.className : 'uc-total';
  };

  handleDynamicClass = (newClass) => {
    this.setState({ dynamicClass: newClass });
  }

  handleOnChange = (e, { value }) => {
    const newClass = this.getClassFromValue(value);
    this.setState({ dynamicClass: newClass });
    this.props.onChange(value);
  };

  render() {
    const { options, value } = this.props;
    const { dynamicClass } = this.state;

    return (
      <Dropdown
        fluid
        selection
        floating
        className={`uc-dropdown-show-all-items uc-booking-status-dropdown ${dynamicClass}`}
        options={options.map(option => ({
          key: option.key,
          value: option.value,
          text: (
            <div>
              <span className="uc-booking-status-text">{option.count}</span>
              <div style={{ marginBottom: '4px' }} />
              <span className="uc-booking-status-label">{option.valueLabel}</span>
            </div>
          ),
          content: (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="uc-booking-status-item">{option.valueLabel}</span>
              <span className="uc-booking-status-item">{option.count}</span>
            </div>
          ),
        }))}
        onChange={this.handleOnChange}
        value={value}
        icon={<i className="dropdown icon" />}
      />
    );
  }
}

BookingStatusDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    valueLabel: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default BookingStatusDropdown;



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCBookingStatusDropdown.jsx